import { EndpointReponseProps } from "../../types";
import { LoanRequestStatus } from "../../types/Loan";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
// const baseURL = "http://localhost:8085/api";

export const Endpoints = {
   GetCheckServerHealth: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/health`,
         method: "GET",
      };
   },

   /**
    * Authentication Routes
    */
   GetLogin: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/auth/login`,
         method: "POST",
      };
   },

   GetVerifyLoginOtp: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/auth/verify-login-otp`,
         method: "POST",
      };
   },

   GetResendLoginOtp: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/auth/resend-login-otp`,
         method: "POST",
      };
   },

   GetProfile: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/auth/profile`,
         method: "GET",
      };
   },

   GetVerifyTwoFactorLogin: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/auth/verify-2fa-login`,
         method: "POST",
      };
   },

   /**
    * Two-Factor Authentication Routes
    */
   GetTwoFactorGenerateSecret: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/two-factor/generate`,
         method: "POST",
      };
   },
   GetTwoFactorEnable: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/two-factor/enable`,
         method: "POST",
      };
   },
   GetTwoFactorDisable: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/two-factor/disable`,
         method: "POST",
      };
   },
   GetTwoFactorStatus: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/two-factor/status`,
         method: "GET",
      };
   },

   GetUpdatePassword: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/user/auth/change-password`,
         method: "POST",
      };
   },

   /**
    * Loans Routes
    */
   GetAvailableLoanPlans: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans`,
         method: "GET",
      };
   },
   CreateLoanProduct: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans`,
         method: "POST",
      };
   },
   UpdateLoanProduct: (loanId: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/${loanId}`,
         method: "PATCH",
      };
   },
   ToggleLoanProductStatus: (loanId: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/${loanId}/toggle-status`,
         method: "PATCH",
      };
   },
   DeleteLoanProduct: (loanId: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/${loanId}`,
         method: "DELETE",
      };
   },
   GetLoanRequests: (page: number, limit: number, status?: LoanRequestStatus): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/requests?page=${page}&limit=${limit}&status=${status}`,
         method: "GET",
      };
   },
   GetSingleLoanRequest: (requestID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/requests/${requestID}`,
         method: "GET",
      };
   },
   UpdateLoanRequestStatus: (requestID: string, status: LoanRequestStatus): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/requests/${requestID}/status`,
         method: "PATCH",
      };
   },
   DisburseLoan: (requestID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/requests/${requestID}/disburse`,
         method: "POST",
      };
   },
   SetLoanDirectDebitAmount: (requestID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/loans/requests/${requestID}/direct-debit`,
         method: "POST",
      };
   },
   GetFees: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/fees`,
         method: "GET",
      };
   },
   CreateFee: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/fees`,
         method: "POST",
      };
   },
   UpdateFee: (feeId: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/fees/${feeId}`,
         method: "PATCH",
      };
   },
   DeleteFee: (feeId: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/fees/${feeId}`,
         method: "DELETE",
      };
   },

   /**
    * KYC Routes
    */
   GetKYCRequests: (page: number, limit: number): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/kyc?page=${page}&limit=${limit}`,
         method: "GET",
      };
   },
   GetSingleKYCRequest: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/kyc/user/${userID}`,
         method: "GET",
      };
   },
   GetUpdateKYCRequestStatus: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/kyc/user/${userID}/verify`,
         method: "PATCH",
      };
   },

   /**
    * User Routes
    */
   GetUsers: (
      page: number,
      limit: number,
      search?: string,
      status?: string,
      emailVerified?: string,
      phoneVerified?: string,
      kycStatus?: string
   ): EndpointReponseProps => {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("limit", limit.toString());
      if (search) params.append("search", search);
      if (status && status !== "all") params.append("status", status);
      if (emailVerified && emailVerified !== "all") params.append("emailVerified", emailVerified);
      if (phoneVerified && phoneVerified !== "all") params.append("phoneVerified", phoneVerified);
      if (kycStatus && kycStatus !== "all") params.append("kycStatus", kycStatus);

      return {
         route: `${baseURL}/admin/users?${params.toString()}`,
         method: "GET",
      };
   },
   GetSingleUser: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/users/${userID}`,
         method: "GET",
      };
   },
   WaiveUserBvn: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/users/${userID}/waive-bvn`,
         method: "POST",
      };
   },
   DeleteUser: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/users/${userID}`,
         method: "DELETE",
      };
   },
   VerifyUserDirectDebitMandate: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/users/${userID}/verify-direct-debit-mandate`,
         method: "POST",
      };
   },
   RetryUserDirectDebitActivation: (userID: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/users/${userID}/retry-direct-debit-activation`,
         method: "POST",
      };
   },

   /**
    * Upload a file to the server
    */
   GetUploadFile: (): EndpointReponseProps => {
      return {
         route: `${baseURL}/user/files/upload`,
         method: "POST",
      };
   },

   /**
    * Reports Routes
    */
   GetLoanPortfolioReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/loan-portfolio${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetDisbursementReport: (
      startDate?: number,
      endDate?: number,
      status?: "completed" | "pending" | "failed"
   ): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      if (status) params.append("status", status);
      return {
         route: `${baseURL}/admin/reports/disbursements${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetDisbursementList: (
      page?: number,
      limit?: number,
      startDate?: number,
      endDate?: number,
      status?: "completed" | "pending" | "failed"
   ): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (page) params.append("page", page.toString());
      if (limit) params.append("limit", limit.toString());
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      if (status) params.append("status", status);
      return {
         route: `${baseURL}/admin/reports/disbursements/list${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetRepaymentReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/repayments${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetRevenueReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/revenue${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetTransactionReport: (
      page: number,
      limit: number,
      startDate?: number,
      endDate?: number,
      type?: string,
      status?: string
   ): EndpointReponseProps => {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("limit", limit.toString());
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      if (type) params.append("type", type);
      if (status) params.append("status", status);
      return {
         route: `${baseURL}/admin/reports/transactions?${params.toString()}`,
         method: "GET",
      };
   },
   GetFeeCollectionReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/fee-collection${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetRiskComplianceReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/risk-compliance${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetOperationalReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/operational${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetLoanSchedulingReport: (startDate?: number, endDate?: number): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      return {
         route: `${baseURL}/admin/reports/loan-scheduling${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetLoanScheduleLoansList: (
      startDate?: number,
      endDate?: number,
      page?: number,
      limit?: number,
      search?: string
   ): EndpointReponseProps => {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate.toString());
      if (endDate) params.append("endDate", endDate.toString());
      if (page) params.append("page", page.toString());
      if (limit) params.append("limit", limit.toString());
      if (search && search.trim().length) params.append("search", search.trim());
      return {
         route: `${baseURL}/admin/reports/loan-scheduling/loans${params.toString() ? `?${params.toString()}` : ""}`,
         method: "GET",
      };
   },
   GetLoanScheduleDetail: (loanRequestId: string): EndpointReponseProps => {
      return {
         route: `${baseURL}/admin/reports/loan-scheduling/${loanRequestId}/detail`,
         method: "GET",
      };
   },
   ExportLoanSchedule: (loanRequestId: string, format: "csv" | "pdf"): EndpointReponseProps => {
      const params = new URLSearchParams();
      params.append("format", format);
      return {
         route: `${baseURL}/admin/reports/loan-scheduling/${loanRequestId}/export?${params.toString()}`,
         method: "GET",
      };
   },
};
